import layer0 from "./0.png";
import layer1 from "./1.png";

export const layers = [layer0, layer1];
